/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const AlertBubble16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            d="M8.905 1A6.09 6.09 0 0115 7.084c0 3.36-2.729 5.917-6.095 5.917H7.83l-3.754 1.927a.767.767 0 01-.736-.049.743.743 0 01-.34-.642v-2.782c-1.343-1.157-2-2.591-2-4.37A6.09 6.09 0 017.095 1h1.81zm0 1A5.09 5.09 0 0114 7.084c0 2.808-2.28 4.917-5.095 4.917H7.6L4 13.839v-2.83l-.326-.315C2.551 9.726 2 8.572 2 7.084A5.09 5.09 0 017.095 2zM8 8.685c-.268 0-.5.222-.5.496v.823c0 .274.224.496.5.496.268 0 .5-.222.5-.496v-.823a.498.498 0 00-.5-.496zM8 3.5a.51.51 0 00-.5.509v3.13c0 .286.224.51.5.51a.51.51 0 00.5-.51V4.01A.501.501 0 008 3.5z"
            fill={vars.bdlGray}
            fillRule="evenodd"
        />
    </AccessibleSVG>
);

export default AlertBubble16;
